export default "__VITE_ASSET__DDn6RH9s__"